import React, { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import AuthImaage from "../../assets/images/authbanner.png";
import { useForm, SubmitHandler } from "react-hook-form";
import { API_ROUTES } from "@/services/environment";
import { POST } from "@/services/api";
import Alert from "@/components/alert/Alert";
import FormPasswordInput from "@/components/formHookInput/formPasswordInput";
import useLoading from "@/hooks/useLoading";
import useError from "@/hooks/useError ";
import { AuthModal, ButtonLarge, passwordValidator } from "@thdinc/hpf-shared";

const ResetPassword = () => {
  const { resetPasswordRoute, checkForgetToken } = API_ROUTES;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const token = searchParams.get("token");
  const { isLoading, startLoading, stopLoading } = useLoading();
  const [error, setCustomError] = useError()

  // first validate token
  useEffect(() => {

    (async () => {
      try {
        //1) check if token is in url
        if (token) {
          // 2) checl token is valid
          const res = await POST(checkForgetToken, { token: token });
          if (!res.data === true) {
            Alert({ message: "Token expired", type: "error" });
            navigate("/login");
          }
        } else {
          navigate("/login");
        }
      } catch (error) {
        console.log(error);
      }
    })();
  }, []);

  type Inputs = {
    password: string;
    confirmPassword: string;
  };
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<Inputs>();
  const password = watch("password");

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      startLoading()
      const res = await POST(resetPasswordRoute, {
        password: data.password,
        token,
      });
      if (res.data.success) {
        Alert({ message: "Password updated successfully", type: "success" });
        navigate("/login");
      } else if (res?.data?.success === false) {
        setCustomError('reset', res?.data?.message)
      }
    } catch (error) {
      console.log(error);
      setCustomError('reset', "Something went wront")
    } finally {
      stopLoading()
    }
  };
  return (
    <div className="container mx-auto h-screen relative">
      <div className="flex flex-col  justify-center  min-h-full ">
        <div className="flex justify-center">
          <img className="w-[500px] hidden lg:block rounded-3xl" src={AuthImaage} alt="" />
          <div className="flex flex-col justify-center lg:-ml-11  ">
            <AuthModal>
              <div className="text-center">
                <p className="text-2xl font-bold ">Reset Password</p>
                <p className=" mt-6">Enter a new password for your account.</p>
              </div>
              <form 
              className="md:min-w-[400px]"
              onSubmit={handleSubmit(onSubmit)}>
                <div>
                  <div className=" font-semibold my-2">New Password</div>
                  <FormPasswordInput
                    type="password"
                    placeholder="Password"
                    register={register("password", {
                      required: "Password is required",
                      pattern: passwordValidator,
                    })}
                    error={errors.password}
                  />
                </div>
                <div className="mt-8">
                  <div className=" font-semibold my-2">Confirm Password</div>
                  <FormPasswordInput
                    type="password"
                    placeholder="Confirm Password"
                    register={register("confirmPassword", {
                      validate: (value) =>
                        value === password || "The passwords do not match!",
                      required: "Confirm Password is required",
                      // pattern: passwordValidator
                    })}
                    error={errors.confirmPassword}
                  />
                </div>
                {error?.name === 'reset' && <p className="text-center text-primary-red my-2">{error.message}</p>}
                <div className=" mt-5">
                  <ButtonLarge classes="min-w-full" disabled={isLoading} type="submit">
                    {" "}
                    {isLoading ? "Processing" : "Reset"}
                  </ButtonLarge>
                </div>
              </form>
            </AuthModal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
